var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12V1.55001C1 1.55001 1.5 1 3 1C4.5 1 5.5 2.1 7 2.1C8.5 2.1 9 1.55 9 1.55V8.15C9 8.15 8.5 8.7 7 8.7C5.5 8.7 4.5 7.6 3 7.6C1.5 7.6 1 8.15 1 8.15",
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.d3ea671dfbb7fd0a65bbe2c36ee78916.svg";
export { ForwardRef as ReactComponent };